<template>
  <div>
    <div v-if="!planDetails">Loading...</div>
    <div v-else>
      <div class="card-header">
        <span class="title"> {{ planDetails.name }}</span>
      </div>

      <div class="price">
        ${{
          planDetails._metadata.price !== undefined
            ? planDetails._metadata.price / 100 > 0 ? planDetails._metadata.price * 1000 / 100000  : "Free"
            : ""
        }}<span  class="text-small">per {{planDetails.cycle}}</span>
        <!-- v-if="planDetails.id != 'partyline-common-free'" -->
      </div>

      <div
        class="text"
        v-for="(item, i) in planDetails.chargeItems"
        :key="i">
        <i class="el-icon-check"></i>
        {{
          item.quantity !== undefined
            ? handleDisplay(item)
            : ""
        }}
      </div>

      <!-- <div class="text">
        <i class="el-icon-check"></i>
        {{
          planDetails.chargeItems[0].quantity !== undefined
            ? displayHour(planDetails.chargeItems[0].quantity)
            : ""
        }}
      </div>
      <div class="text">
        <i class="el-icon-check"></i>
        {{
          planDetails.chargeItems[1].quantity !== undefined
            ? displayParticipant(
                planDetails.chargeItems[1].quantity
              )
            : ""
        }}
      </div>
      <div class="text">
        <i class="el-icon-check"></i>
        {{
          planDetails.chargeItems[2].quantity !== undefined
            ? displayOutput(planDetails.chargeItems[2].quantity)
            : ""
        }}
      </div> -->

      <div
        class="card-footer"
        style="width: 100%">
        <el-button
          v-if="planDetails.isSub"
          type="success">Subscribed</el-button>
        <el-button
          v-else-if="planDetails._metadata.price == 0"
          type="success"
          @click="handlecheckuser(planDetails.id)">Try for free</el-button>
        <el-button
          v-else
          type="success"
          @click="handlecheckuser(planDetails.id)">Subscribe Now</el-button>
      </div>
    </div>
    <el-dialog
      :visible.sync="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div>
        <div class="container-pop">
          <iframe
            frameborder="0"
            width="100%"
            height="400"
            :src="paymentPath" />
        </div>
      </div>
    </el-dialog>
    <ConfirmPay
      v-if="showConfirm"
      type="pay"
      :price="planDetails._metadata.price"
      :cycle="planDetails.cycle"
      @handlePay="handlePay"
      @handleClose="showFreeConfirm = false" />
  </div>
</template>

<script>
// import { GET_PLAN_DETAILS } from "../queries.js";
import { subscriptionNow, customerPortalStatus } from '../mutation.js'
import json from '../json/data.json'
import { Message } from 'element-ui'
import ConfirmPay from './ConfirmPay.vue'
import { checkSub } from '../common/checkuser'
// import Helper from "../common/helper";

export default {
  name: 'CardPlanDetails',
  props: {
    planDetails: {
      type: Object
    },
    indexData: {
      type: Number
    },
    emailid: {
      type: String
    },
    session: {
      type: String
    }
  },
  components: {
    ConfirmPay
  },
  data () {
    return {
      dummyData: json.subscriptionPlan,
      // planDetails: [],
      attachedItems: null,
      checkData: false,
      loading: false,
      error: false,

      customerId: this.emailid,
      sessionId: this.session,
      visible: false,
      paymentPath: null,
      cbInstance: null,
      showConfirm: false
    }
  },
  // apollo: {
  //   plan: {
  //     query: GET_PLAN_DETAILS,
  //     fetchPolicy: "network-only",
  //     notifyOnNetworkStatusChange: true,
  //     credentials: true,
  //     variables () {
  //       return {
  //         customerId: this.customerId,
  //         product: "Partyline",
  //         planId: this.planName,
  //       };
  //     },
  //     result ({ data, loading, error }) {
  //       if (data) {
  //         this.checkData = true;
  //         this.planDetails[this.indexData] = data.plan;
  //         console.log(data.plan);
  //         //json.parse()
  //         //this.attachedItems = data.plan.attachedItems;
  //         this.loading = loading;
  //         this.error = error;
  //       }
  //     },
  //   },
  // },
  methods: {
    handlecheckuser () {
      const params = {
        customerId: this.emailid,
        product: 'Partyline'
      }
      checkSub(params).then(res => {
        console.log(res)
        this.showConfirm = res === 'canCharge'
      })
    },
    handlePay () {
      this.showConfirm = false
      this.subscriptionNow(this.planDetails.id)
    },
    handleDisplay (value) {
      if (!value || !value.addonId) return ''
      switch (value.addonId) {
        case 'partyline-hour':
          return this.displayHour(value.quantity)

        case 'partyline-output':
          return this.displayOutput(value.quantity)

        case 'partyline-participant':
          return this.displayParticipant(value.quantity)

        default:
          break
      }
    },
    displayHour (_data) {
      let hour = _data >= 2 ? 'Hours' : 'Hour'
      return _data + ' ' + hour
    },
    displayParticipant (_data) {
      let participant = _data >= 2 ? 'Participants' : 'Participant'
      return 'Up to ' + _data + ' ' + participant
    },
    displayOutput (_data) {
      let Ouput = _data >= 2 ? 'Ouputs' : 'Ouput'
      return 'Up to ' + _data + ' ' + Ouput
    },
    subscriptionNow (planName) {
      console.log('planName', planName)
      // this.$apollo.mutate({
      //   mutation: subscriptionNow,
      //   variables: {
      //     customerId: this.customerId,
      //     product: "Partyline",
      //     planId: planName,
      //   },
      //   result({ data, loading, error }) {
      //     console.log("data==>>>" + data);
      //     console.log("loading==>>>" + loading);
      //     console.log("error==>>>" + error);
      //     // if(data){
      //     //     this.checkData = true;
      //     //     this.planDetails = data.plan;
      //     //     this.loading = loading;
      //     //     this.error = error;
      //     // }
      //   },
      // });
      const chargeItems = {}
      this.planDetails.chargeItems.forEach(i => {
        chargeItems[i.addonId] = i.quantity
      })
      console.log(chargeItems)
      this.$apollo
        .mutate({
          mutation: subscriptionNow,
          variables: {
            customerId: this.emailid,
            product: 'Partyline',
            planId: planName,
            description: 'kk_test',
            chargeItems: JSON.stringify(chargeItems)
          }
        })
        .then((data) => {
          console.log(data)
          // console.log("data ---> ", data);
          // this.visible = true;
          // this.paymentPath = "https://tvunetworks-test.chargebee.com/pages/v3/V0QigzgDi3StLz2gcB3XDFgPd6b2dKvq/"
          // this.paymentPath = data.data.checkoutNewSubscription.url;
          // console.log(this.paymentPath);
          this.openCheckout(data.data.checkoutNewSubscription.url)
        })
        .catch((error) => {
          // console.log("error---->", JSON.stringify(error));
          // console.log("error---->", error.graphQLErrors[0].message);
          let errorMessage =
            error &&
            error.graphQLErrors &&
            error.graphQLErrors[0] &&
            error.graphQLErrors[0].message

          console.log(errorMessage)

          errorMessage &&
            Message({
              message: errorMessage,
              type: 'error',
              customClass: 'mzindex'
            })
        })
    },
    openCheckout (checkUrl) {
      let hasPay = false
      this.cbInstance.openCheckout({
        hostedPage: () => {
          // 打开订阅或者支付的窗口
          return new Promise((resolve) => {
            resolve({ url: checkUrl })
          })
        },
        success: async (hostedPageId) => {
          console.log(hostedPageId)
          hasPay = true
          this.customerPortalStatus(hostedPageId)
        },
        error: (err) => {
          console.log(err)
        },
        close: () => {
          console.log('close')
          hasPay && window.parent.postMessage({
            type: 'close',
            data: null
          }, '*')
        }
      })
    },
    customerPortalStatus (hostedPageId) {
      this.$apollo.mutate({
        mutation: customerPortalStatus,
        variables: {
          customerId: this.emailid,
          hostedPageId
        }
      }).then((data) => {
        console.log(data)
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    // const emailid = Helper.getKey("emailid");
    // const sessionId = Helper.getKey("session");
    // this.customerId = emailid;
    // this.sessionId = sessionId;
    // if (emailid) {
    //   this.customerId = emailid;
    // } else {
    // }
    // if (sessionId) {
    //   this.sessionId = sessionId;
    // } else {
    // }
    // console.log("this.customerId --> ", this.customerId)
    // console.log("this.sessionId --> ", this.sessionId)
    this.cbInstance = window.Chargebee.getInstance()
  }
}
</script>
